export default __webpack_public_path__ + "static/media/sign-in-podcast-cover.6895a38c.jpeg";